import { render, staticRenderFns } from "./WeekDaysView.vue?vue&type=template&id=64e387b9&scoped=true"
import script from "./WeekDaysView.vue?vue&type=script&lang=js"
export * from "./WeekDaysView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e387b9",
  null
  
)

export default component.exports